
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_4142_4906)"}},[_c('path',{attrs:{"d":"M1.592 9.575h5.046a.841.841 0 00.841-.84V3.687a.841.841 0 00-.84-.84H1.591a.841.841 0 00-.84.84v5.046a.841.841 0 00.84.841zm.841-5.046h3.364v3.364H2.433V4.53zm15.979.841h-8.41a.841.841 0 100 1.682h8.41a.84.84 0 100-1.682zm0 8.41h-8.41a.841.841 0 000 1.682h8.41a.841.841 0 100-1.682zM3.225 17.144h.01a.84.84 0 00.59-.243l3.402-3.364a.84.84 0 10-1.178-1.196l-2.8 2.766-1.052-1.093a.84.84 0 10-1.21 1.17l1.644 1.708a.842.842 0 00.594.252z","fill":"currentColor","stroke":"currentColor","stroke-width":".35"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_4142_4906"}},[_c('path',{attrs:{"fill":"currentColor","transform":"translate(.001 1.996)","d":"M0 0h20v16H0z"}})])])])
          )
        }
      }
    